import { render, staticRenderFns } from "./unitario.vue?vue&type=template&id=b2925c0c"
import script from "./unitario.vue?vue&type=script&lang=js"
export * from "./unitario.vue?vue&type=script&lang=js"
import style0 from "./unitario.vue?vue&type=style&index=0&id=b2925c0c&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports